import { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { logoutUser } from "../redux/actions/LoginActions";
import { useNavigate } from "react-router-dom";
import { setResetTimerFunction } from "../redux/store";


const useAutoLogout = (timeout = 15 * 60 * 1000) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const timer = useRef(null);

  const resetTimer = useCallback(() => {
    if (timer.current) {
      clearTimeout(timer.current);
    }

    timer.current = setTimeout(() => {
      dispatch(logoutUser());
    navigate("/");
    }, timeout);
  }, [dispatch,navigate, timeout]);

  useEffect(() => {
    const events = [
      "mousemove",
      "keydown",
      "click",
      "scroll",
      "collapse", 
      "recherche",
      "input",
      "change", 
      "changeFile", 
       "print"
    ];

    const handleActivity = () => resetTimer();

    events.forEach(event => {
      if (event === "collapse") {
        const collapseElement = document.getElementById("collapse");
        collapseElement?.addEventListener("collapse", handleActivity);
      }

      if (event === "recherche") {
        const searchInput = document.getElementById("search");
        searchInput?.addEventListener("input", handleActivity);
      } else if (event === "input") {
        const inputs = document.querySelectorAll("input, select, textarea, input[type='date']");
        inputs.forEach(input =>
          input.addEventListener("input", handleActivity)
        );
      } else if (event === "change") {
        const selects = document.querySelectorAll("select");
        selects.forEach(select =>
          select.addEventListener("change", handleActivity)
        );
      } else if (event === "changeFile") {
        const fileInputs = document.querySelectorAll("input[type='file']");
        fileInputs.forEach(input =>
          input.addEventListener("change", handleActivity)
        );
      } else {
        window.addEventListener(event, handleActivity);
      }
    });

    setResetTimerFunction(resetTimer);

    resetTimer(); 

    return () => {
      events.forEach(event => {
        if (event === "collapse") {
          const collapseElement = document.getElementById("collapse");
          collapseElement?.removeEventListener("collapse", handleActivity);
        }
        if (event === "recherche") {
          const searchInput = document.getElementById("search");
          searchInput?.removeEventListener("input", handleActivity);
        } else if (event === "input") {
          const inputs = document.querySelectorAll("input, select, textarea, input[type='date']");
          inputs.forEach(input =>
            input.removeEventListener("input", handleActivity)
          );
        } else if (event === "change") {
          const selects = document.querySelectorAll("select");
          selects.forEach(select =>
            select.removeEventListener("change", handleActivity)
          );
        } else if (event === "changeFile") {
          const fileInputs = document.querySelectorAll("input[type='file']");
          fileInputs.forEach(input =>
            input.removeEventListener("change", handleActivity)
          );
        } else {
          window.removeEventListener(event, handleActivity);
        }
      });
      clearTimeout(timer.current);
      setResetTimerFunction(null);
    };
  }, [resetTimer]); 

  return null; 
};

export default useAutoLogout;